import actions from 'redux/pagination/actions'

export const init = {
  fetching: false,
  result: undefined,
  next_page_url: undefined,
  error: false,
  total: undefined,
  count: undefined,
}

function updatePagination(state = init, action) {
  switch (action.type) {
    case actions.FETCHING:
      return {
        ...state,
        fetching: true,
      }
    case actions.FULFILLED:
      return {
        ...state,
        fetching: false,
        result:
          action.payload.current_page === 1
            ? action.payload.result
            : [...(state.result || []), ...action.payload.result],
        next_page_url: action.payload.next_page_url,
        total: action.payload.total,
        count: action.payload.count,
      }
    case actions.REJECTED:
      return {
        ...state,
        fetching: false,
        error: true,
      }
    case actions.CLEAR:
      return init
    default:
      return state
  }
}

export default function pagination(state = {}, action) {
  switch (action.type) {
    case actions.FETCHING:
    case actions.FULFILLED:
    case actions.REJECTED:
    case actions.CLEAR:
      return {
        ...state,
        [action.url]: updatePagination(state[action.url], action),
      }
    default:
      return state
  }
}
